'use client';

import { useEffect } from 'react';
import Smartlook from 'smartlook-client';

const SmartlookResolver = ({ smartlookKey }: { smartlookKey: string }) => {
  useEffect(() => {
    if (!window?.smartlook && smartlookKey) {
      Smartlook.init(smartlookKey, { region: 'eu' });
    }
  });
  return '';
};

export default SmartlookResolver;
